import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DropdownDirective } from './dropdown.directive';
import { DropZoneDirective } from './drop-zone.directive';

@NgModule({
  declarations: [
    DropdownDirective,
    DropZoneDirective
  ],
  exports: [
    CommonModule,
    DropdownDirective
  ]
})
export class SharedModule {}




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts